<template>
  <div class="paragraph-m_h mb-6">
    <b>Внимание!</b> Диапазон включает нижнюю, но не включает верхнюю границу возраста. Например, диапазон 3-7 включает
    в себя детей 3, 4, 5 и 6 лет.
  </div>

  <div class="input-placeholder mb-1 text-ordinary">Правила расчёта возраста туриста</div>
  <skeleton-loader v-if="!ageSettings" width="200px" type="paragraph-m_h" />
  <div v-else class="paragraph-m_h font-600">{{ determineAgeMethod }}</div>

  <property-block class="mt-6" title="Турист без места" :value="ageSettings?.noSeatAge">
    <template #text>
      <div class="paragraph-l font-600 mb-2">Минимальный возраст заезда</div>
      <div class="paragraph-s_h text-secondary">
        Турист младше указанного возраста не может быть заселен. Максимальное значение — 18 лет.
      </div>
    </template>

    <template #content>
      <div class="input-placeholder text-ordinary mb-1">Минимальный возраст</div>
      <skeleton-loader v-if="!ageSettings" width="60px" type="paragraph-m_h" />
      <div v-else class="paragraph-m_h font-600">{{ ageSettings.initialAge }}</div>
    </template>
  </property-block>

  <property-block class="mt-6 mb-4" title="Турист без места" :value="ageSettings?.noSeatAge">
    <template #text>
      <e-checkbox v-if="ageSettings" :model-value="!!ageSettings.noSeatAge" disabled label="Турист без места" />
      <skeleton-loader v-else width="158px" type="paragraph-m_h" />
    </template>

    <template #content>
      <div class="input-placeholder text-ordinary mb-1">Возраст</div>
      <skeleton-loader v-if="!ageSettings" width="100px" type="paragraph-m_h" />
      <div v-else class="paragraph-m_h font-600">
        <template v-if="ageSettings.noSeatAge">
          {{ `${ageSettings.initialAge} - ${ageSettings.noSeatAge}` }}
        </template>
        <template v-else>Не указано</template>
      </div>
    </template>
  </property-block>

  <divider class="mt-6 mb-8" />

  <property-block class="mt-2" title="Турист без места" :value="ageSettings?.noSeatAge">
    <template #text>
      <div class="paragraph-l mb-2">
        <b>Возраст детей</b>
      </div>
      <div class="paragraph-s_h text-secondary">
        Возрастные группы для гибкой настройки тарификации и установления ограничений
      </div>
    </template>

    <template #content>
      <div v-if="ageSettings" class="d-flex align-center">
        <div class="mr-10">
          <div class="input-placeholder text-ordinary mb-1">Возраст</div>
          <div
            v-for="(category, index) in ageSettings.categories.values"
            :key="index"
            class="paragraph-m_h font-600 mb-1"
          >
            {{ rangeTouristTypesString(category) }}
          </div>
        </div>
      </div>
      <div v-else>
        <div class="input-placeholder text-ordinary mb-1">Возраст</div>
        <skeleton-loader width="100px" type="paragraph-m_h" />
      </div>
    </template>
  </property-block>
</template>

<script setup lang="ts">
import { toRef } from 'vue';
import Divider from '@/core/components/helpers/Divider.vue';
import PropertyBlock from '@/core/components/interface/PropertyBlock.vue';
import SkeletonLoader from '@/core/components/interface/SkeletonLoader.vue';
import { ECheckbox } from '@/core/components/ui';
import { determineAgeMethods } from '@/core/consts/collections';
import { useTariffsStore } from '@/parts/tariffs/store/tariffs';
import { rangeTouristTypesString } from '@/parts/tariffs/utils/tariffs';

const { activeTariff } = useTariffsStore();

const ageSettings = toRef(() => activeTariff.value?.baseSettings?.ageSettings);

const determineAgeMethod = toRef(
  () => determineAgeMethods.find((method) => method.value === ageSettings.value?.determineAgeMethod)?.text,
);
</script>

<style scoped lang="scss"></style>
